export default __webpack_public_path__ + "static/media/Leelakrishnan.43ecaf59.JPG";